import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.set-prototype-of.js";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import lodashGet from 'lodash/get';
import lodashSet from 'lodash/set';
import lodashMap from 'lodash/map';
import has from 'lodash/has';
import cloneDeep from 'lodash/cloneDeep';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import isNull from 'lodash/isNull';
import ExtendableError from 'es6-error';
import stringifyNode from './stringify-node';
import pickWildcards from './pick-wildcards'; // TODO: reorganize validation related methods and errors
// from migrations and errors source files to this tree-utils file
// eslint-disable-next-line import/no-cycle

import { validateNode } from '../migrations';

var BreakWalkError = /*#__PURE__*/function (_ExtendableError) {
  _inherits(BreakWalkError, _ExtendableError);

  var _super = _createSuper(BreakWalkError);

  function BreakWalkError(node) {
    var _this;

    _classCallCheck(this, BreakWalkError);

    _this = _super.call(this, node);
    _this.message = "node walk broke at: ".concat(stringifyNode(node)); // eslint-disable-line no-use-before-define

    return _this;
  }

  return BreakWalkError;
}(ExtendableError); // this is source code from npm `is-promise` package.


export function isPromise(obj) {
  return !!obj && (_typeof(obj) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
} // recurse all nodes in tree and perform an operation
// use the node returned from operation as the base for the next recursive operation

function transformNode(node, schema, iteratee) {
  var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  if (isNull(node)) return node;
  if (isNumber(node)) return node;
  if (isString(node)) return node;

  if (isArray(node)) {
    var output = node.map(function (n, i) {
      return transformNode(n, schema, iteratee, "".concat(key, "[").concat(i, "]"));
    }); // if an iteratee returned a promise, this whole method is async

    if (output.some(isPromise)) return Promise.all(output); // iteratee was always sync.  this method is sync

    return output;
  } // method to recurse into child nodes
  // after iteratee has run for this node
  // transforms all nodes in structured node props
  // declared in schema that exist on this node


  function transformNodeProps(tnode) {
    // `tnode` is the tranformed node returned from iteratee
    // sanity check
    if (!has(tnode, 'type') || !has(tnode, 'props') || !has(schema, tnode.type)) {
      // something is wrong.  validate the node to get useful error message
      validateNode(tnode, key, schema);
    }

    var type = tnode.type,
        props = tnode.props;
    var nodeProps = schema[type].nodeProps;
    var propsKey = key ? "".concat(key, ".props") : 'props'; // case for start node is object vs. array
    // pick out all the structured node props declared in schema that exist on this node

    var propsToTransform = pickWildcards(props, nodeProps); // a map method to transform those props and set the transformed prop value on this node

    var transformNodeProp = function transformNodeProp(val, name) {
      // method to update prop value on node for either sync or async runs
      var updatePropValue = function updatePropValue(v) {
        return lodashSet(tnode.props, name, v);
      }; // recurse down


      var prop = transformNode(val, schema, iteratee, "".concat(propsKey, ".").concat(name)); // set the output on the prop being transformed in the node
      // when recursion is async, wait to update

      if (isPromise(prop)) return prop.then(updatePropValue); // when recursion is sync, update immediately

      return updatePropValue(prop);
    }; // transform all matched node-props


    var output = lodashMap(propsToTransform, transformNodeProp); // return the transformed node after all node-props have been transformed
    // when recursion is async, wait until all props are updated

    if (output.some(isPromise)) {
      return Promise.all(output).then(function () {
        return tnode;
      });
    } // when recursion is sync, immediately return transformed node


    return tnode;
  } // run the iteratee method to transform the node


  var transformed = iteratee(node, key, schema); // when this iteratee is async, wait for it to run
  // before recursing down into child nodes
  // if iteratee returns async at any level of recursion,
  // then the function-call at the top is async/returns a promise

  if (isPromise(transformed)) return transformed.then(transformNodeProps); // iteratee is synchronous. immediately recurse down.

  return transformNodeProps(transformed);
} // recurse through the tree and alter nodes with synchronous or asynchronous operations
// returns promise for transformed node when operations are async
// otherwise returns transformed node


export function transform(node, schema, iteratee) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$mutate = _ref.mutate,
      mutate = _ref$mutate === void 0 ? false : _ref$mutate;

  if (mutate === true) return transformNode(node, schema, iteratee);
  return transformNode(cloneDeep(node), schema, iteratee);
} // recurse through the tree and perform a synchronous operation
// returns undefined

export default function walk(node, schema, iteratee) {
  var walker = function walker(n, key) {
    // assert node is valid to schema
    validateNode(n, key, schema); // run the supplied iteratee method

    if (iteratee(n, key, schema) === false) {
      // break the iteration if `false` was returned
      throw new BreakWalkError(node);
    } // return the original node, recurse down


    return n;
  };

  try {
    // run transform with `mutate: true` to avoid copying data
    transform(node, schema, walker, {
      mutate: true
    });
  } catch (err) {
    if (err instanceof BreakWalkError === false) {
      throw err;
    }
  }
}
/**
 * predicate takes an SC node as a parameter and returns true or false
 * based on whether it is the node that the user is looking for
 *
 * @callback nodePredicateFn
 * @param {Object} node
 * @returns {boolean}
 */

/**
 * Finds the first occurrence of a node based on a supplied predicate function
 *
 * @param {Object} doc
 * @param {Object} schema
 * @param {(nodePredicateFn|string)} predicate node => boolean, or the type of node to find as a string
 * @returns {(undefined|Object)} the first occurrence of the node (BFS) or undefined if none were found
 */

export function find(doc, schema, predicate) {
  var result;
  var predicateFn = typeof predicate === 'string' ? function (node) {
    return node.type === predicate;
  } : predicate;
  walk(doc, schema, function (node) {
    if (predicateFn(node)) {
      result = node;
      throw new BreakWalkError();
    }
  });
  return result;
}
/**
 * Finds multiple nodes based on a supplied predicate function
 *
 * @param {Object} doc
 * @param {Object} schema
 * @param {nodePredicateFn} predicate node => boolean
 * @returns {(Object[])} zero or more found nodes
 */

export function filter(doc, schema, predicate) {
  var results = [];
  var predicateFn = typeof predicate === 'string' ? function (node) {
    return node.type === predicate;
  } : predicate;
  walk(doc, schema, function (node) {
    if (predicateFn(node)) {
      results.push(node);
    }
  });
  return results;
} // lookup node with keypath provided when walking node

export function get(node, key) {
  if (!key) return node;
  return lodashGet(node, key);
}
export function each(node, schema, iteratee) {
  var i = 0; // eslint-disable-next-line no-shadow

  walk(node, schema, function (node, key, schema) {
    var out = iteratee(node, i, schema);
    i += 1;
    return out;
  });
  return node;
} // walks the tree, and maps every node into a flat list

export function map(node, schema) {
  var iteratee = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (n) {
    return n;
  };
  var out = [];
  walk(node, schema, function (n, key) {
    return out.push(iteratee(n, key));
  });
  return out;
} // map the tree, return whole nodes

export function toArray(node, schema) {
  return map(node, schema, function (n) {
    return n;
  });
}